import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/fb-logo.svg'
import _imports_1 from '@/assets/google-logo.svg'
import _imports_2 from '@/assets/tiktok-logo.svg'
import _imports_3 from '@/assets/is-logo.svg'
import _imports_4 from '@/assets/applovin-logo.svg'
import _imports_5 from '@/assets/unity-logo.svg'
import _imports_6 from '@/assets/moloco-logo.png'
import _imports_7 from '@/assets/mintegral-logo.png'


const _hoisted_1 = { class: "intro-container" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"platforms\"><div><img src=\"" + _imports_0 + "\"><br> Facebook </div><div><img src=\"" + _imports_1 + "\"><br> Google </div><div><img src=\"" + _imports_2 + "\"><br> Tiktok </div><div><img src=\"" + _imports_3 + "\"><br> Ironsource </div><div><img src=\"" + _imports_4 + "\"><br> AppLovin </div><div><img src=\"" + _imports_5 + "\"><br> Unity </div><div><img src=\"" + _imports_6 + "\"><br> Moloco </div><div><img src=\"" + _imports_7 + "\"><br> Mintegral </div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Products = _resolveComponent("Products")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('home.header')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('home.subheader')
        }, null, 8, _hoisted_2)
      ])
    ]),
    _createVNode(_component_v_icon, { class: "icon" }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-controller")
      ]),
      _: 1
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('home.platforms')), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.platformsInfo')), 1),
    _hoisted_3,
    _createVNode(_component_v_icon, { class: "icon" }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-controller")
      ]),
      _: 1
    }),
    _createVNode(_component_Products),
    _createVNode(_component_v_icon, { class: "icon" }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-controller")
      ]),
      _: 1
    }),
    _createVNode(_component_v_icon, { class: "icon" }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-controller")
      ]),
      _: 1
    })
  ], 64))
}